
import * as React from 'react';

function findGetParameter(parameterName) {
    let result = null,
        tmp = [];
    console.log(location);
    location.href
    .substr(location.href.indexOf('?') + 1)
        .split('&')
        .forEach(function (item) {
        tmp = item.split('=');
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
    console.log(result);
    return result;
}

class ErrorComponent extends React.Component<{}, {}> {
    render() {
        return (
            <div style={{width:'90%', height:'0', margin:'0px auto', position: 'relative',
                    paddingBottom : '56.25%',
                    paddingTop: '25px'}}>
                <iframe
                    srcDoc={findGetParameter('html')}
                    width='500'  
                    style={
                        {
                           position: 'absolute',
                            top: '5%',
                            left: 0,
                            width: '100%',
                            height: '80%',
                        }
                    }
                />
            </div>
        );
    }
}

export default ErrorComponent;


// WEBPACK FOOTER //
// ./src/components/ErrorComponent.tsx